<template>
    <div class="block-editor meta-send-capi-event">
        <div class="editor-row customize-editor-minimize">
            <div class="editor-row-title">{{ $t("chatbotv2.metaCapiContactId") }}</div>
            <TiptapEditor
                :placeholder="$t('chatbotv2.metaCapiContactIdPh')"
                :show-attributes="true"
                :max-character-count="100"
                v-model="clone.contactId"
            />
        </div>

        <div class="editor-row">
            <div class="editor-row-title">{{ $t("chatbotv2.metaCapiEventType") }}</div>
            <a-select class="classic-new-select" :placeholder="$t('chatbotv2.metaCapiSelectEventType')" v-model="clone.eventType">
                <a-select-option value="LeadSubmitted">{{ $t("chatbotv2.metaCapiLeadSubmitted") }}</a-select-option>
                <a-select-option value="Purchase">{{ $t("chatbotv2.metaCapiPurchase") }}</a-select-option>
                <a-select-option value="InitiateCheckout">{{ $t("chatbotv2.metaCapiInitiateCheckout") }}</a-select-option>
                <a-select-option value="AppointmentBooked">{{ $t("chatbotv2.metaCapiAppointmentBooked") }}</a-select-option>
                <a-select-option value="AddToCart">{{ $t("chatbotv2.metaCapiAddToCart") }}</a-select-option>
                <a-select-option value="ViewContent">{{ $t("chatbotv2.metaCapiViewContent") }}</a-select-option>
                <a-select-option value="OrderCreated">{{ $t("chatbotv2.metaCapiOrderCreated") }}</a-select-option>
                <a-select-option value="OrderShipped">{{ $t("chatbotv2.metaCapiOrderShipped") }}</a-select-option>
            </a-select>
        </div>

        <div
            class="editor-row customize-editor-minimize"
            v-if="['Purchase', 'OrderCreated', 'OrderShipped'].includes(clone.eventType)"
        >
            <div class="editor-row-title">{{ $t("chatbotv2.metaCapiCurrency") }}</div>
            <TiptapEditor
                :placeholder="$t('chatbotv2.metaCapiCurrencyPh')"
                :show-attributes="true"
                :max-character-count="10"
                v-model="clone.currency"
            />
        </div>

        <div
            class="editor-row customize-editor-minimize"
            v-if="['Purchase', 'OrderCreated', 'OrderShipped'].includes(clone.eventType)"
        >
            <div class="editor-row-title">{{ $t("chatbotv2.metaCapiAmount") }}</div>
            <TiptapEditor
                :placeholder="$t('chatbotv2.metaCapiAmountPh')"
                :show-attributes="true"
                :max-character-count="50"
                v-model="clone.value"
            />
        </div>

        <div class="editor-row">
            <div class="editor-row-title">{{ $t("chatbotv2.metaCapiExtraFields") }}</div>
            <div class="custom-data-list">
                <div v-for="(item, index) in clone.customData" :key="index" class="custom-data-item">
                    <input v-model="item.key" :placeholder="$t('chatbotv2.metaCapiKeyPh')" class="key-input" />
                    <TiptapEditor
                        :placeholder="$t('chatbotv2.metaCapiValuePh')"
                        :show-attributes="true"
                        :max-character-count="200"
                        v-model="item.value"
                        class="value-input"
                    />
                    <button @click="removeCustomData(index)" class="remove-btn">
                        <i class="material-icons">delete</i>
                    </button>
                </div>
                <button @click="addCustomData" class="add-btn">
                    <i class="material-icons">add</i>
                    {{ $t("chatbotv2.metaCapiAddField") }}
                </button>
            </div>
        </div>

        <div class="info-box">
            <i class="material-icons">info</i>
            <p>
                {{ $t("chatbotv2.metaCapiInfo") }}
            </p>
        </div>
    </div>
</template>

<script>
import log2 from "../../../../../../utils/log2";
import _ from "lodash";
import TiptapEditor from "../common/TiptapEditor";
import { mapState } from "vuex";

const log = log2("MetaSendCapiEvent");
export default {
    name: "MetaSendCapiEvent",
    components: { TiptapEditor },
    props: ["value"],
    data() {
        return {
            clone: _.cloneDeep(this.value),
        };
    },
    computed: {
        ...mapState({
            siteId: (state) => state.site.site._id,
        }),
    },
    methods: {
        addCustomData() {
            if (!Array.isArray(this.clone.customData)) {
                this.clone.customData = [];
            }
            this.clone.customData.push({
                key: "",
                value: "",
            });
        },
        removeCustomData(index) {
            this.clone.customData.splice(index, 1);
        },
    },
    mounted() {
        if (!this.clone.contactId) {
            this.clone.contactId = "{{visitor.id}}";
        }
    },
    watch: {
        clone: {
            deep: true,
            handler(newValue) {
                this.$emit("input", newValue);
            },
        },
    },
};
</script>

<style lang="scss" scoped>
.block-editor.meta-send-capi-event {
    padding: 20px;
    display: flex;
    align-items: flex-start;
    flex-direction: column;
    gap: 20px;

    .ant-select {
        width: 100%;
    }

    .editor-row {
        width: 100%;

        .editor-row-title {
            font-weight: bold;
            font-size: 16px;
            display: flex;
            align-items: center;
            gap: 5px;
            margin-bottom: 8px;
        }

        .custom-data-list {
            display: flex;
            flex-direction: column;
            gap: 10px;

            .custom-data-item {
                display: flex;
                gap: 10px;
                align-items: center;

                .key-input {
                    width: 30%;
                    padding: 8px 12px;
                    border: 1px solid #d9d9d9;
                    border-radius: 4px;
                    font-size: 14px;

                    &:focus {
                        outline: none;
                        border-color: #40a9ff;
                        box-shadow: 0 0 0 2px rgba(24, 144, 255, 0.2);
                    }
                }

                .value-input {
                    flex: 1;
                }

                .remove-btn {
                    padding: 4px 8px;
                    border: none;
                    background: #ff4d4f;
                    color: white;
                    border-radius: 4px;
                    cursor: pointer;
                    display: flex;
                    align-items: center;
                    transition: all 0.2s;

                    &:hover {
                        background: #ff7875;
                    }

                    i {
                        font-size: 16px;
                    }
                }
            }

            .add-btn {
                width: fit-content;
                padding: 6px 12px;
                border: 1px dashed #d9d9d9;
                background: transparent;
                border-radius: 4px;
                cursor: pointer;
                display: flex;
                align-items: center;
                gap: 5px;
                transition: all 0.2s;

                &:hover {
                    border-color: #40a9ff;
                    color: #40a9ff;
                }

                i {
                    font-size: 16px;
                }
            }
        }
    }

    .info-box {
        display: flex;
        gap: 10px;
        padding: 12px;
        background: #e3f2fd;
        border-radius: 6px;
        border-left: 4px solid #2196f3;
        width: 100%;

        i {
            color: #2196f3;
            font-size: 20px;
        }

        p {
            margin: 0;
            font-size: 13px;
            color: #1565c0;
            line-height: 1.5;
        }
    }
}
</style>

